<template>
  <f7-popup class="popup-user-reset-password" :id="nameId" :opened="popupOpened"
    @popup:opened="popupOpened = true"
    @popup:closed="popupOpened = false">
    <div class="container-user-reset-password">
      <br/>
      <form-write-group-label-input v-model="login" isMandatory
        :idLabel="$t('common.idtfr')" :placeholderValue="$t('common.idtfr')"
        inputType="text">
      </form-write-group-label-input>
      <button round class="button-action milkyBlockBlack" @click="resetPassword()">{{ $t('administration.reset_password') }}</button>
    </div>
  </f7-popup>
</template>

<script>

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  name: 'cm-user-reset-password',
  props: {
    closeButton: Boolean
  },
  data: () => {
    return {
      popupOpened: false,
      nameId: '',
      login: ''
    }
  },
  created () {
    this.nameId = 'cm-user-reset-password-' + this.closeButton
  },
  methods: {
    resetPassword () {
      let that = this
      this.$f7.modal({
        title: 'Reset password in progress',
        text: '<span class="preloader"></span>'
      })
      this.$engine.user.resetPassword(this.login)
      .then(resp => {
        setTimeout(function () {
          that.$f7.closeModal()
          if (resp.status === 200) {
            that.$f7.modal({
              title: 'Email sent',
              text: 'An email has been sent to your mail box if your account exist'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/login/', force: false, ignoreCache: false})
            }, 2000)
          }
        }, 1000)
      })
      .catch(error => {
        console.log('error')
        errorMessageAlert(error, that, that.$i18n)
      })
    }
  }
}
</script>

<style scoped>
.popup-user-reset-password {
  border-radius: 15px;
  background-color: rgba(255, 255, 255, .95);
  height: 180px;
  width: 50%;
}
.container-user-reset-password {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// CMUserResetPassword.vue?a04bd222